module.exports = __webpack_public_path__ + "static/media/join_bottom_photo.3fbfeb8c.jpg";